var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.001,
    height: 28,
    viewBox: "0 0 28.001 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_home",
    transform: "translate(-35.999 -82)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 28,
    height: 28,
    transform: "translate(36 82)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    d: "M24.4,18.241l.021.544v10.09a2.051,2.051,0,0,1-2.082,2.015H6.982A2.052,2.052,0,0,1,4.9,28.875V18.26l2.366-2.142.021,2.647v9.74H22.031V16.1Zm3.511-2.263L16.28,5.131a2.373,2.373,0,0,0-3.238,0L1.414,15.98a2.383,2.383,0,0,0-.129,3.349L14.663,6.859,26.293,17.727l1.74,1.6A2.388,2.388,0,0,0,27.908,15.977Z",
    transform: "translate(35.34 78.008)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHome);
export default __webpack_public_path__ + "static/media/ico-home.ae2399485e947eeda98c02e783ae1839.svg";
export { ForwardRef as ReactComponent };